import Vue from 'vue'
import App from './App'
import router from './router';
import store from './store';
import model from './model';
import apiUrl from './data/apiUrl';
import framework from './framework/index'
import VueAMap from 'vue-amap';

Vue.use(model);
Vue.use(apiUrl);
Vue.use(framework);
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Geocoder', 'AMap.Geolocation', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MouseTool'],
  uiVersion: '1.0.11'
});

new Vue({
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  data: {
    eventHub: new Vue(),
    charts: []
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js